export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=405ed31e09266dfe8bc9aa0b61e2ccaac45a63f4de&name=revalidateCommunity!'